<!-- eslint-disable vue/no-unused-refs -->
<template>
  <QS-scroller-box>
    <form-text-box
      ref="baseInfoInfo"
      :column="3"
      :dataList="createOrderInfo.list.c_baseInfoList"
      :model="createOrderInfo.model.c_baseInfoModel"
      :rules="createOrderInfo.rules.c_baseInfoRules"
    />
    <el-divider></el-divider>
    <form-text-box
      ref="customerInfo"
      :column="3"
      :dataList="createOrderInfo.list.c_customerInfoList"
      :model="createOrderInfo.model.c_customerInfoModel"
    />
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="confirm" size="mini" type="primary"
        >确认，下一步</el-button
      >
    </template>
  </QS-scroller-box>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    createOrderInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    ...mapGetters(['rentMallOpenSwitch']),
  },
  methods: {
    // 取消
    cancel() {
      this.$emit('cancel')
    },
    // 确认
    confirm() {
      this.$refs.baseInfoInfo.getRefs().validate((valid) => {
        if (valid) {
          // 保存顶部预览数据
          this.handelToppreview()
          this.$emit('confirm')
        }
      })
    },
    handelToppreview() {
      const elFormItem = this.createOrderInfo.list.c_baseInfoList?.find(
        (item) => item.itemConfig.prop === 'storeId',
      )
      const someStore = elFormItem?.elConfig?.options?.list?.find(
        (item) =>
          Number(item.id) ===
            Number(this.createOrderInfo.model.c_baseInfoModel.storeId),
      )
      // 暂时注释
      // eslint-disable-next-line vue/no-mutating-props
      this.createOrderInfo.model.topPreviewModel.storeName =
          someStore?.name || ''
      const {
        topPreviewModel,
        c_customerInfoModel,
        c_baseInfoModel,
      } = this.createOrderInfo.model

      // 暂时注释
      // eslint-disable-next-line vue/no-mutating-props
      this.createOrderInfo.model.topPreviewModel = {
        ...topPreviewModel,
        customerName: c_customerInfoModel.customerName,
        rentCalculationRules: c_baseInfoModel.rentCalculationRules,
        idCardNo: c_customerInfoModel.idCardNo,
        customerTel: c_customerInfoModel.customerTel,
      }
    },
  },
}
</script>
